import { createAction } from '@ngrx/store';

export class AlphabetSoupPhaseActions {
	public static finish = createAction('[AlphabetSoupPhase] Finish');
}
